import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F3800PIIIConsolService {

  constructor(private http: HttpClient) { }

  saveCreditForms(
    baseUrl: string, 
    returnClobSettingsObj: any, 
    creditFormSaveDtls: any[], 
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // Use filter parameters passed from component (replaces workspaceFactory.activeScreen.filters.getFilterParams())

    // Build payload structure exactly like in original AngularJS
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ clob_data: JSON.stringify(creditFormSaveDtls) }, params);
    params = _.extend({ clob_setting: JSON.stringify(returnClobSettingsObj) }, params);
    params.process_name = "CREDITPIII-CONSOL-GRID-SAVE";
    
    // Add ALL required configuration fields
    params.tax_year = returnClobSettingsObj.tax_year || rowData.TAX_YEAR || filterParams.tax_year || '';
    params.scenario = returnClobSettingsObj.scenario || rowData.SCENARIO || filterParams.scenario || '';
    params.jcd_key = returnClobSettingsObj.jcd_key || rowData.JCD_KEY || filterParams.jcd_key || '';
    params.scenarioCode = rowData.SCENARIO_CODE || filterParams.scenarioCode || rowData.SCENARIO || filterParams.scenario || '';
    params.is_issue_key_enabled = 'N';
    params.combination_key = returnClobSettingsObj.combination_key || rowData.COMBINATION_KEY || filterParams.combination_key;

    // Add checkLockedbj for lock checking
    const checkLockedbj = [{
      "leid": rowData.LEID || rowData.SOURCE_LEID || "",
      "consol_group_key": String(rowData.CONSOL_GROUP_KEY || "1"),
      "combination_key": String(returnClobSettingsObj.combination_key || rowData.COMBINATION_KEY || filterParams.combination_key || "")
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Convert params to URLSearchParams for form-urlencoded format (like AngularJS)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(
      `${baseUrl}/saveJsonObject?action_code=xhphao`,
      urlEncoded.toString(),
      httpOptions
    );
  }
} 